import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'lui-layout-main',
    templateUrl: './layout-main.component.html',
    styleUrls: ['./layout-main.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LayoutMainComponent {
  @Input() showCookies!: boolean;
}
